import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Params } from '@angular/router';

@Component({
  selector: 'un-info-carousel',
  templateUrl: './info-carousel.component.html',
  styleUrls: ['./info-carousel.component.less'],
  standalone: false,
})
export class InfoCarouselComponent {
  @Input() heading?: string;
  @Input() headingClass?: string;
  @Input() description?: string;
  @Input() btnText?: string;
  @Input() btnLink?: string | string[];
  @Input() btnQuery?: Params;
  @Input() scrollPx = 150;
  @Input() display: 'default' | 'card' = 'default';
  @Input() layout: 'vertical' | 'horizontal' = 'horizontal';
  @Output() btnClick = new EventEmitter<void>();

  @ViewChild('carousel', {
    static: true,
  })
  carousel: ElementRef;

  constructor(public el: ElementRef) {}

  scrollLeft() {
    this.carousel.nativeElement.scrollLeft -= this.scrollPx;
  }

  scrollRight() {
    this.carousel.nativeElement.scrollLeft += this.scrollPx;
  }
}
